/**
 * ScoreTag — colour-coded pill showing a score value.
 * Colors: SEO = blue, AEO = amber/brown, GEO = green, overall = ink.
 */

interface Props {
  score: number | null;
  kind?: 'seo' | 'aeo' | 'geo' | 'overall';
  size?: 'sm' | 'md' | 'lg';
}

const KIND_CLASSES: Record<string, string> = {
  seo: 'bg-blue-50 text-blue-700 border border-blue-200',
  aeo: 'bg-amber-50 text-amber-700 border border-amber-200',
  geo: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  overall: 'bg-slate-100 text-slate-700 border border-slate-200',
};

const SIZE_CLASSES: Record<string, string> = {
  sm: 'text-xs px-2 py-0.5 font-semibold',
  md: 'text-sm px-3 py-1 font-semibold',
  lg: 'text-xl px-4 py-1.5 font-bold',
};

export function ScoreTag({ score, kind = 'overall', size = 'md' }: Props) {
  if (score === null) {
    return (
      <span
        className={`inline-block rounded-full font-mono ${KIND_CLASSES[kind]} ${SIZE_CLASSES[size]}`}
      >
        —
      </span>
    );
  }
  return (
    <span
      className={`inline-block rounded-full font-mono ${KIND_CLASSES[kind]} ${SIZE_CLASSES[size]}`}
    >
      {score}
    </span>
  );
}
